import {
    Autocomplete,
    Button,
    Card,
    CardContent,
    Grid,
    Divider, Table,
    MenuItem,
    TextField,
    Typography,
    TextareaAutosize,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import { Language } from "react-transliterate";
import Languages from "../../../Languages";
import DeleteIcon from '@mui/icons-material/Delete';
import { getId, getISTDate } from "../../../utils/Constant";
import dayjs from "dayjs";

type Props = {};

const EditIndentForm = (props: Props) => {
    let navigate = useNavigate();
    const location = useLocation();
    console.log('location', location.state)
    const { t } = useTranslation();
    const [lang, setLang] = useState<Language>("en");
    const { defaultValues } = getISTDate();
    const [toaster, setToaster] = useState(false);
    const [tableData, setTableData] = useState<any>([{
        "indentChildID": -1,
        indentID: -1,
        itemID: -1,
        id: 0,
        itemName: '',
        unit: '',
        qty: '',
        rate: '',
        amount: ''
    }]);

    useEffect(() => {
        getstoreData();
        GetUnitData();
        GetitemData();
        GetempData();
        if (location?.state?.id) {
            getTransDataById(location.state.id);
        }
    }, []);
    const [unitOptions, setUnitOptions] = useState([
        { value: "-1", label: t("text.SelectUnitId") },
    ]);
    const [storeOption, setstoreOption] = useState([
        { value: -1, label: t("text.id") },
    ]);
    const [itemOption, setitemOption] = useState([
        { value: -1, label: t("text.itemMasterId") },
    ]);
    const [empOption, setempOption] = useState([
        { value: "-1", label: t("text.empid") },
    ]);


    const UserId = getId();

    const GetitemData = async () => {
        const collectData = {
            itemMasterId: -1,
        };
        const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["itemName"],
                value: data[index]["itemMasterId"],
                unitId:data[index]["unitId"],
                rate:data[index]["rate"],
            });
        }


        console.log('itemId', arr)
        setitemOption(arr);
    };

    const getstoreData = async () => {
        const collectData = {
            id: -1,
            unit: -1,
        };
        const response = await api.post(`StoreMaster/GetStoreMaster`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["storeName"],
                value: data[index]["id"],
            });
        }
        setstoreOption(arr);
    };

    const GetUnitData = async () => {
        const collectData = {
            unitId: -1,
        };
        const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["unitName"],
                value: data[index]["unitId"],
                unitId: data[index]["unitId"],
            });
        }
        setUnitOptions(arr);
    };

    const GetempData = async () => {
        const collectData = {
            empid: -1,
            userId: "",
            empName: "",
            empMobileNo: "",
            empDesignationId: -1,
            empDeptId: -1,
            empStateId: -1,
            empCountryID: -1,
            empCityId: -1,
            empPincode: 0,
            roleId: ""
        };
        const response = await api.post(`EmpMaster/GetEmpmaster`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["empName"],
                value: data[index]["empid"],
            });
        }
        setempOption(arr);
    };
    const getTransDataById = async (id: any) => {
        const collectData = {
            "indentID": id
        };
        try {
            const result = await api.post(`indentParent/GetindentParent`, collectData);
            const data = result.data.data;

            console.log("🚀 ~ getTransDataById ~ data:", data);

            if (data.length > 0) {
                const formattedData = data[0]['indentinv'].map((item: any, index: number) => ({
                    indentChildID: item.indentChildID,
                    indentID: item.indentID,
                    itemID: item.itemID,
                    id: index + 1,
                    itemName: item.itemName,
                    unit: item.unit,
                    qty: item.qty,
                    rate: item.rate,
                    amount: item.amount
                }));
                // setTableData(formattedData);

                setTableData([
                    ...formattedData,
                    {
                        id: 0,
                        indentId: 0,
                        itemId: 0,
                        quantity: 0,
                        rate: 0,
                        amount: 0,
                        approveQuantity: 0,
                        fyId: 0,
                        srn: 0,
                        isDelete: true,
                        unitId: 0,
                        unitName: "",
                    },
                ]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }


    const validateRow = (row: any) => {
        return row.itemName && row.unit && row.qty >= 1 && row.rate > 0;
    };

    const formik = useFormik({
        initialValues: {
            "indentID": location.state.indentID,
            "indentNo": location.state.indentNo,
            "indentDate": dayjs(location.state.indentDate).format("YYYY-MM-DD"),
            "reqBefDate": dayjs(location.state.reqBefDate).format("YYYY-MM-DD"),
            "deptID": location.state.deptID,
            "emp_name": location.state.emp_name,
            "empid": location.state.empid,
            "remark": location.state.remark,
            "instID": location.state.instID,
            "sessionID": location.state.sessionID,
            "approve": location.state.approve,
            "user_id": location.state.user_id,
            "divisionId": location.state.divisionId,
            "forward_Status": location.state.forward_Status,
            "forward_By": location.state.forward_By,
            "forward_On": defaultValues,
            "storeId": location.state.storeId,
            "l3_Status": location.state.l3_Status,
            "l3_By": location.state.l3_By,
            "l3_On": defaultValues,
            "mode": location.state.mode,
            "estimateNo": location.state.estimateNo,
            "workType": location.state.workType,
            "proposalNo": location.state.proposalNo,
            "patCodeNo": location.state.patCodeNo,
            "toStoreId": location.state.toStoreId,
            "toDivisionId": location.state.toDivisionId,
            "is_PMN": location.state.is_PMN,
            "stage": location.state.stage,
            "isApprove": location.state.isApprove || false,
            "createdBy":UserId,
            "updatedBy": UserId,
            "createdOn":new Date().toISOString(),
            "updatedOn":new Date().toISOString(),
            "indentinv": []
        },
        validationSchema: Yup.object({
            emp_name: Yup.string()
                .required(t("text.reqEmpName")),
            
            storeId: Yup.string()
                .required(t("text.reqStoreId")),
        }),
        onSubmit: async (values) => {

            const validateRow = (row: any) => {
                const missingFields: string[] = [];

                if (!row.itemName) missingFields.push('Item Name');
                if (!row.unit) missingFields.push('Unit');
                if (row.qty < 1) missingFields.push('Quantity');
                if (row.rate <= 0) missingFields.push('Rate');

                return missingFields;
            };

            const firstRow = tableData[0];

            const missingFields = validateRow(firstRow);

            if (missingFields.length > 0) {
                alert(`Please fill in the following fields in the first row:\n${missingFields.join('\n')}`);
                return;
            }

            const validTableData = tableData.filter(validateRow);

            if (validTableData.length === 0) {
                alert("Please add some data in the table for further processing.");
                return;
            }
            const response = await api.post(
                `indentParent/AddUpdateindentParent`,
                {
                    ...values, indentinv: validTableData.slice(0, validTableData.length - 1)
                }
            );
            if (response.data.isSuccess) {
                setToaster(false);
                toast.success(response.data.mesg);
                navigate("/Inventory/IndentForm");
            } else {
                setToaster(true);
                toast.error(response.data.mesg);
            }
        },
    });

    const back = useNavigate();

    const handleInputChange = (index: number, field: string, data: any) => {
        const newData = [...tableData];

        if (field === 'itemName') {
            newData[index].itemID = data.value || '';
            newData[index].itemName = data.label || '';
            newData[index].unit = String(data.unitId) || '';
            newData[index].rate = Number(data.rate) || 0;

        } else {
            newData[index][field] = data;
        }

        if (field === 'qty' ) {
            newData[index].qty = data;
        }

        if (['qty', 'rate', 'unit'].includes(field)) {
            newData[index].amount = newData[index].qty * newData[index].rate || 0;
        }

        setTableData(newData);

        if (
            newData[index].itemName &&
            newData[index].unit &&
            newData[index].qty >= 1 &&
            newData[index].rate > 0 &&
            index === tableData.length - 1
        ) {
            addRow();
        }
    };

    const addRow = () => {
        setTableData([...tableData, { indentID: -1, itemID: -1, id: tableData.length + 1, itemName: '', unit: '', qty: 0, rate: 0, amount: 0 }]);
    };

    const deleteRow = (index: any) => {
        const newData = tableData.filter((_: any, i: any) => i !== index);
        setTableData(newData);
    };

    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh",
                }}
            >
                <CardContent>

                    <Grid item xs={12} container spacing={2} >
                        <Grid item lg={2} md={2} xs={2} marginTop={2}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Grid>
                        <Grid item lg={7} md={7} xs={7} alignItems="center" justifyContent="center">
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="center"
                            >
                                {t("text.EditIndent")}
                            </Typography>
                        </Grid>

                        <Grid item lg={3} md={3} xs={3} marginTop={3}>
                            <select
                                className="language-dropdown"
                                value={lang}
                                onChange={(e) => setLang(e.target.value as Language)}
                            >
                                {Languages.map((l: any) => (
                                    <option key={l.value} value={l.value}>
                                        {l.label}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="indentNo"
                                    name="indentNo"
                                    label={<CustomLabel text={t("text.AutoIndentForm")} required={false} />}
                                    value={formik.values.indentNo}
                                    placeholder={t("text.AutoIndentForm")}
                                    size="small"
                                    fullWidth
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="indentDate"
                                    name="indentDate"
                                    label={<CustomLabel text={t("text.indentDate")} required={false} />}
                                    value={formik.values.indentDate}
                                    placeholder={t("text.indentDate")}
                                    size="small"
                                    fullWidth
                                    type="date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="reqBefDate"
                                    name="reqBefDate"
                                    label={<CustomLabel text={t("text.reqBefDate")} required={false} />}
                                    value={formik.values.reqBefDate}
                                    placeholder={t("text.reqBefDate")}
                                    size="small"
                                    fullWidth
                                    type="date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>




                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={empOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue("emp_name", newValue?.value?.toString());
                                        formik.setFieldValue("empNames", newValue?.label);
                                    }}
                                    value={
                                        empOption.find(
                                            (opt: any) => opt.value === Number(formik.values.emp_name)
                                        ) || null
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.emp_name")} required={true} value={formik.values.emp_name} />}
                                        />
                                    )}
                                />
                                {formik.touched.emp_name && formik.errors.emp_name && (
                                    <div style={{ color: "red", margin: "5px" }}>{typeof formik.errors.emp_name === 'string' ? formik.errors.emp_name : ''}</div>
                                )}
                            </Grid>

                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    id="estimateNo"
                                    name="estimateNo"
                                    label={
                                        <CustomLabel text={t("text.estimateNo")} required={false}  />
                                    }
                                    value={formik.values.estimateNo}
                                    placeholder={t("text.estimateNo")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {/* {formik.touched.estimateNo && formik.errors.estimateNo && (
                                    <div style={{ color: "red", margin: "5px" }}>{typeof formik.errors.estimateNo === 'string' ? formik.errors.estimateNo : ''}</div>
                                )} 
                            </Grid> */}

                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={storeOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue("storeId", newValue?.value);
                                    }}
                                    value={
                                        storeOption.find(
                                            (opt) => opt.value === formik.values.storeId
                                        ) || null
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.storeId")} required={true} value={formik.values.storeId} />}
                                        />
                                    )}
                                />
                                {formik.touched.storeId && formik.errors.storeId && (
                                    <div style={{ color: "red", margin: "5px" }}>{typeof formik.errors.storeId === 'string' ? formik.errors.storeId : ''}</div>
                                )}
                            </Grid>

                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    id="patCodeNo"
                                    name="patCodeNo"
                                    label={<CustomLabel text={t("text.patCodeNo")} required={false} />}
                                    value={formik.values.patCodeNo}
                                    placeholder={t("text.patCodeNo")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid> */}

                            <Grid item xs={12}>
                                <Table style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black' }}>
                                    <thead style={{ backgroundColor: '#2196f3', color: '#f5f5f5' }}>
                                        <tr>

                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px', width: '5%', height: '35px' }}>{t("text.SrNo")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px' }}>{t("text.ItemName")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px', width: '15%' }}>{t("text.Unit")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px' }}>{t("text.Quantity")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px' }}>{t("text.Rate")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px' }} title="Total Ammounts" >{t("text.totalAmounts")}</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', width: '5%' }}>{t("text.Action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.map((row: any, index: any) => (
                                            <tr key={row.id} style={{ border: '1px solid black' }}>
                                                <td style={{ border: '1px solid black', textAlign: 'center' }}>{index + 1}</td>

                                                <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        id="combo-box-demo"
                                                        options={itemOption}
                                                        fullWidth
                                                        size="small"
                                                        value={itemOption.find((opt: any) => opt.value == row.itemID) || null}
                                                        onChange={(e, newValue) => {
                                                            handleInputChange(index, 'itemName', newValue || "");
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={t("text.selectItem")}
                                                            />
                                                        )}
                                                    />
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        id="combo-box-demo"
                                                        options={unitOptions}
                                                        fullWidth
                                                        size="small"
                                                        value={unitOptions.find((opt: any) => opt.value == row.unit) || null}
                                                        onChange={(e, newValue) => handleInputChange(index, 'unit', newValue?.value?.toString())}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={t("text.EnterUnit")}
                                                            />
                                                        )}
                                                    />
                                                </td>

                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '5px', width: '10%', height: '35px' }}>
                                                    <TextField
                                                        size="small"
                                                        value={row.qty }
                                                        onChange={(e) => handleInputChange(index, 'qty', parseFloat(e.target.value) || 0)}
                                                        onFocus={(e) => e.target.select()}
                                                    />
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', width: '10%', height: '35px' }}>
                                                    <TextField
                                                        size="small"
                                                        value={row.rate}
                                                        // onChange={(e) => handleInputChange(index, 'rate', parseFloat(e.target.value) || 0)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                handleInputChange(index, 'rate', value);
                                                            }
                                                        }}
                                                        onFocus={(e) => e.target.select()}
                                                        inputProps={{ readOnly: true }}
                                                    />
                                                </td>

                                                <td style={{ border: '1px solid black', textAlign: 'center', width: '10%', height: '35px' }}>
                                                    <TextField
                                                        value={typeof row.amount === "string" ? row?.amount : parseFloat(row.amount || "0").toFixed(2)}
                                                        size="small"
                                                        inputProps={{ "aria-readonly": true }}
                                                    />
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'center' }} onClick={() => deleteRow(index)}>
                                                    <DeleteIcon color='secondary' />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <TextareaAutosize
                                    id="remark"
                                    name="remark"
                                    placeholder="Remark"
                                    value={formik.values.remark}
                                    onChange={formik.handleChange}
                                    minRows={1}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        fontSize: '16px',
                                        resize: 'none',
                                    }} />
                            </Grid>

                            <Grid item lg={6} sm={6} xs={12}>
                                <Grid>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: `var(--header-background)`,
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item lg={6} sm={6} xs={12}>
                                <Button
                                    type="reset"
                                    fullWidth
                                    style={{
                                        backgroundColor: "#F43F5E",
                                        color: "white",
                                        marginTop: "10px",
                                    }}
                                    onClick={(e: any) => formik.resetForm()}
                                >
                                    {t("text.reset")}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </div>
        </div>
    );
};

export default EditIndentForm;